import { DomUtil } from "../util/DomUtil";
import { WyanokeUtil } from "../util/WyanokeUtil";

export class RedirectUnauthenticated {

    public async init(): Promise<void> {
        const requireAuthElement = DomUtil.query(document.body, '[data-requires-auth="true"]', false);
        if (!requireAuthElement) { return; }
        let redirectUrl = requireAuthElement.dataset.redirectForUnauth;
        if (!redirectUrl) { return; }
        const profile = await WyanokeUtil.loadUserProfile(true, false);
        if (!profile) {
            const userAgent = navigator.userAgent.toLowerCase();
            if (userAgent.includes("elevenlabs")) {
                console.log("ElevenLabs user agent detected, allowing anonymous access");
                return;
            }

            if (redirectUrl.toLowerCase() === "parent" && !userAgent.includes("elevenlabs")) {
                const lastSlashIndex =
                    window.location.pathname.lastIndexOf("/");
                redirectUrl =
                    window.location.pathname.slice(0, lastSlashIndex);
            }
            console.log("Anonymous on Auth page. Redirecting to: "
                + redirectUrl);
            window.location.replace(redirectUrl.length === 0 ?
                "/" :
                redirectUrl);
        }

    }
}
